import { UUID_REGEX } from '@constants/routes';
import { generatePath } from '@helpers/route';

const path = '/settings/special-considerations';

const ENTITY_ID = `:entityId(${UUID_REGEX})`;
const ENTITY_JURISDICTION_ID = `:entityJurisdictionId(${UUID_REGEX})`;

export const specialConsiderationsRoutes = {
  ROOT: {
    get rule() {
      return `${path}`;
    },
    get make() {
      return () => this.rule;
    },
  },
  SKU: {
    get rule() {
      return `${path}/sku/${ENTITY_ID}?/${ENTITY_JURISDICTION_ID}?`;
    },
    get make() {
      return (entityId?: string, entityJurisdictionId?: string) =>
        generatePath(this.rule, { entityId, entityJurisdictionId });
    },
  },
  POLISH_SKU: {
    get rule() {
      return `${path}/polish-sku/${ENTITY_ID}?`;
    },
    get make() {
      return (entityId?: string) => generatePath(this.rule, { entityId });
    },
  },
  BANKING_DETAILS: {
    get rule() {
      return `${path}/bank-details/:entityId?/:regId?`;
    },
    get make() {
      return (entityId?: string, regId?: string) => generatePath(this.rule, { entityId, regId });
    },
  },
  BANKING_DETAILS_EDIT: {
    get rule() {
      return `${path}/bank-details/:entityId/:regId/edit`;
    },
    get make() {
      return (entityId: string, regId: string) => generatePath(this.rule, { entityId, regId });
    },
  },
};
